import type { inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from './api-types.js';

export type Saidas = inferRouterOutputs<AppRouter>;

export type Sessao = NonNullable<Saidas['auth']['eu']>;
export type Empresa = Sessao['empresas'][number];
export type Papel = Empresa['papel'];

export type TotaisResumo = Saidas['resumo']['totais'];
export type Totais = TotaisResumo['geral'];

export type DocumentoResumo = Saidas['documentos']['listar']['itens'][number];
export type DocumentoDetalhe = Saidas['documentos']['obter'];
export type ItemDocumento = DocumentoDetalhe['itens'][number];

export type Obra = Saidas['obras']['listar']['obras'][number];
export type AlertaLinha = Saidas['alertas']['listar']['itens'][number];
export type AlertaAgrupado = Saidas['alertas']['porCodigo'][number];
export type ParametroHistorico = Saidas['parametros']['historico'][number];
export type ParametrosVigentes = Saidas['parametros']['vigentes'];

export type Severidade = 'crit' | 'warn' | 'info';

export const ROTULO_SEVERIDADE: Record<Severidade, string> = {
  crit: 'Crítica',
  warn: 'Atenção',
  info: 'Verificar',
};

export type CampoOrdem =
  | 'dataEmissao'
  | 'valorTotal'
  | 'icms'
  | 'iss'
  | 'retInss'
  | 'retIss'
  | 'emitenteNome';
